const _temp0 = require("./_shared/layout/column.view.less");

const _temp1 = require("./_shared/layout/standard.view.js");
const _temp2 = require("./_shared/layout/standard.view.less");



const _temp3 = require("./activity/recent/recent.view.less");



const _temp4 = require("./blog/recent/recent.view.less");


const _temp5 = require("./blog/tag/tag.view.less");


const _temp6 = require("./blog/view/view.view.js");
const _temp7 = require("./blog/view/view.view.less");


const _temp8 = require("./blog/_shared/tag/wantMorePosts.view.less");



const _temp9 = require("./blog/comment/create/create.view.less");


const _temp10 = require("./blog/comment/edit/edit.view.less");


const _temp11 = require("./blog/comment/pending/pending.view.less");


const _temp12 = require("./blog/comment/preview/preview.view.less");


const _temp13 = require("./blog/comment/_shared/js/commentContent.view.js");

const _temp14 = require("./blog/comment/_shared/js/commentForm.view.js");


const _temp15 = require("./blog/comment/_shared/tag/emojis.view.js");
const _temp16 = require("./blog/comment/_shared/tag/emojis.view.less");

const _temp17 = require("./blog/comment/_shared/tag/formEtiquette.view.less");





const _temp18 = require("./people/view/view.view.less");



const _temp19 = require("./shortUrl/create/create.view.less");



module.exports = {
  "_shared":   {
    "layout":     {
      "column":       {
        "less": _temp0
      },
      "standard":       {
        "js": _temp1,
        "less": _temp2
      }
    }
  },
  "activity":   {
    "recent":     {
      "recent":       {
        "less": _temp3
      }
    }
  },
  "blog":   {
    "recent":     {
      "recent":       {
        "less": _temp4
      }
    },
    "tag":     {
      "tag":       {
        "less": _temp5
      }
    },
    "view":     {
      "view":       {
        "js": _temp6,
        "less": _temp7
      }
    },
    "_shared":     {
      "tag":       {
        "wantMorePosts":         {
          "less": _temp8
        }
      }
    },
    "comment":     {
      "create":       {
        "create":         {
          "less": _temp9
        }
      },
      "edit":       {
        "edit":         {
          "less": _temp10
        }
      },
      "pending":       {
        "pending":         {
          "less": _temp11
        }
      },
      "preview":       {
        "preview":         {
          "less": _temp12
        }
      },
      "_shared":       {
        "js":         {
          "commentContent":           {
            "js": _temp13
          },
          "commentForm":           {
            "js": _temp14
          }
        },
        "tag":         {
          "emojis":           {
            "js": _temp15,
            "less": _temp16
          },
          "formEtiquette":           {
            "less": _temp17
          }
        }
      }
    }
  },
  "people":   {
    "view":     {
      "view":       {
        "less": _temp18
      }
    }
  },
  "shortUrl":   {
    "create":     {
      "create":       {
        "less": _temp19
      }
    }
  }
}